export default async (to, from, next) => {
  const avaliableDirectPaths = ['index', 'student']

  if (!from.name && !avaliableDirectPaths.includes(to.name)) {
    next({ name: 'index' })
  } else {
    next()
  }
}
